import { Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from '@/pages/Login'
import { MfaVerifyPage } from '@/pages/MfaVerify'
import { MfaSetupPage } from '@/pages/MfaSetup'
import { SetupPasswordPage } from '@/pages/SetupPassword'
import { DashboardPage } from '@/pages/Dashboard'
import { UsersPage } from '@/pages/Users'
import { TokensPage } from '@/pages/Tokens'
import { InvitesPage } from '@/pages/Invites'
import { AuditPage } from '@/pages/Audit'
import { SettingsPage } from '@/pages/Settings'
import { SeedbotPage } from '@/pages/Seedbot'
import { PumpfunPage } from '@/pages/Pumpfun'
import { PositionsPage } from '@/pages/Positions'
import { TreasuryPage } from '@/pages/Treasury'
import { InfrastructurePage } from '@/pages/Infrastructure'
import { GlobalMetricsPage } from '@/pages/GlobalMetrics'
import { InvestorDashboard } from '@/pages/InvestorDashboard'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { InvestorLayout } from '@/components/layout/InvestorLayout'

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/mfa-verify" element={<MfaVerifyPage />} />
      <Route path="/mfa-setup" element={<MfaSetupPage />} />
      <Route path="/setup-password" element={<SetupPasswordPage />} />

      {/* Investor routes */}
      <Route element={<InvestorLayout />}>
        <Route path="/investor" element={<InvestorDashboard />} />
      </Route>

      {/* Protected admin routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/tokens" element={<TokensPage />} />
        <Route path="/invites" element={<InvitesPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/seedbot" element={<SeedbotPage />} />
        <Route path="/pumpfun" element={<PumpfunPage />} />
        <Route path="/positions" element={<PositionsPage />} />
        <Route path="/treasury" element={<TreasuryPage />} />
        <Route path="/infrastructure" element={<InfrastructurePage />} />
        <Route path="/global-metrics" element={<GlobalMetricsPage />} />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}
